import {Box, Illustration, Tile, Text, HorizontalLine} from "@mbank-design/design-system/components";
import {
    TwoManHandshakeBriefcaseCorporate
} from "@mbank-design/design-system/illustrations";
import {SpeakerInvitationCreateMessage} from "../../../model/SpeakerInvitationCreateMessage";
import React from "react";
import ConferenceLocation from "./ConferenceLocation";
import ConferenceDates from "./ConferenceDates";

interface ConferenceTileProps {
    invitation: SpeakerInvitationCreateMessage
}

export default function ConferenceTile({invitation} : ConferenceTileProps) {
    
    return (
      <Box>
          <Tile padding={24}>
              <Box display={"flex"} justifyContent={"center"}>
                  <Illustration illustrationComponent={ TwoManHandshakeBriefcaseCorporate } />    
              </Box>
              <Box marginBottom={16}>
                <Text as={"h2"}>welcome to the conference {invitation.conferenceName}</Text>
              </Box>
              <ConferenceLocation conferenceLocation={invitation?.conferenceLocation} />
              <Box paddingLeft={24} marginBottom={16} marginTop={16}>
                  <HorizontalLine />
              </Box>
              <ConferenceDates conferenceDateFrom={invitation.conferenceDateFrom} conferenceDateTo={invitation.conferenceDateTo} />
          </Tile>
      </Box>  
    );
}